export class SelectEvent extends Event {
  /** The search query that was used to select the command. */
  search: string;

  constructor(search: string) {
    super('select');
    this.search = search;
  }
}
